import { render, staticRenderFns } from "./unit_card.vue?vue&type=template&id=ab47e2fc&"
import script from "./unit_card.vue?vue&type=script&lang=js&"
export * from "./unit_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports